import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Grid, Paper, Table, TableBody, TableContainer, TableHead, TableRow, Tooltip, Typography, TablePagination, Button } from "@mui/material";
import styles from "../../../styles.module.css";
import { getDeliveryChallanList, editDeleteDeliveryChallan } from "../../../actions/actions";
import {
  ActionMsg,
  AddButton,
  Breadcrumb,
  CustomePopover,
  dateConversion,
  DeleteDialog,
  ExcelDownload,
  HandleCloseSnackbar,
  SearchInput,
  StyledTableCell,
  StyledTableRow,
  useMessageHandler
} from "../../reusableComponent/Reusables";
import deliveryChallanService from "../../../services/deliveryChallan.Service";
import HeaderSection from "../../reusableComponent/HeaderSection";
import CloseIcon from '@mui/icons-material/Close';
import EmptyDeliveryChallanPrint from "./PrintEmptyDeliveryChallan";
import ReactToPrint from "react-to-print";
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import empty_delivery_challan from "../../../services/empty_delivery_challan";
import CustomPagination from "../../reusableComponent/CustomPagination";

// Assuming customer data might be in Redux or passed as a prop
const EmptyDeliveryChallanList = ({ customerData = {} }) => {
  const dispatch = useDispatch();
  const login_details = sessionStorage.getItem('loginUser');
  const userD = JSON.parse(login_details);
  const userInfo = userD.result.userInfo;

  const dateConversion = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };


  const [isDelete, setIsDelete] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState();
  const [sortBy, setSortBy] = useState(null);
  const totalCount = useSelector(state => state.delivery_challan.total_count || 0);
  const defaultRowsPerPage = useSelector(state => state.delivery_challan.rows_per_page || 15);
  const [rows, setRows] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [openCylinderDialog, setOpenCylinderDialog] = useState(false);

  const [dialogTitle, setDialogTitle] = useState("Cylinder Details");

  const fields = ["entry_no", "entry_date", "depot_name", "table_details", "vehicle_no", "driver_name", "from_depot_name"];
  const labels = ["Entry NO", "Entry Date", "Depot Name", "No Of Cylninder ", "Vehicle No", "Driver Name", "From Depot Name"];

  const [customermap, setCustomer] = useState({});
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedCylinderDetails, setSelectedCylinderDetails] = useState([]);
  const [total_count, setTotalCount] = useState(null)
  useEffect(() => {
    setTotalCount(rows[0]?.totalCount);
  }, [rows]);
  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: defaultRowsPerPage
  });

  useEffect(() => {
    setController(prev => ({
      ...prev,
      rowsPerPage: defaultRowsPerPage,
      page: 0,
    }));
  }, [defaultRowsPerPage]);

  const ComponentToPrintWrapper = ({ quotationPrint }) => {
    const ref = useRef();
    return (
      <div style={{ display: "flex" }}>
        <ReactToPrint
          trigger={() => <span style={{ display: 'flex', justifyContent: 'center' }}> <PrintOutlinedIcon /> <span style={{ marginLeft: '22px' }}>  Print Record </span> </span>}
          content={() => ref.current}
        />
        <div style={{ display: 'none' }}>
          <EmptyDeliveryChallanPrint ref={ref} salesOrderPrint={quotationPrint} />
        </div>
      </div>
    );
  };

  const handleChangePage = (event, newPage) => {
    setController({
      ...controller,
      page: newPage,
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setController({
      ...controller,
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0,
    });
  };

  const fetchData = async () => {
    try {
      const params = {
        page: controller.page,
        size: controller.rowsPerPage,
        searchKey: searchKey,
      };
      const response = await empty_delivery_challan.getEmptyDeliverychallanList(params);
      setRows(response);
    } catch (error) {
     
    }
  };

  const handleSearch = async (e) => {
    const searchValue = e.target.value;
    setSearchKey(searchValue);
    const params = {
      page: controller.page,
      size: searchValue === '' ? controller.rowsPerPage : (rows[0]?.total_count || 0),
      searchKey: searchValue,
    };
    try {
      await fetchData(params);
    } catch (error) {
      console.error("Error in handleSearch:", error);
    }
  }; 

  useEffect(() => {
    fetchData();
  }, [controller]);

  const deleteRecord = async (id) => {
    try {
      await empty_delivery_challan.editDeleteEmptyDeliverychallan({
        entry_id: id,
        changedUpdatedValue: "delete"
      });
      setIsDelete(false);
      fetchData();
      setSuccessMessage("Record deleted successfully");
    } catch (error) {
      setSuccessMessage("Error deleting record");
    }
  };

  const handleDelete = (functions) => {
    console.log("handleDelete called with data:", functions);
    setIsDelete(true);
    setDeleteInfo(functions);
  };

  const handleClose = (event, reason) => {
    setIsDelete(false);
    setDeleteInfo(null);
  };

  const [successMessage, setSuccessMessage] = useState(null);
  const respMsgState = useSelector((state) => state.delivery_challan.message);

  const { shouldShowMsg, responseMessage } = useMessageHandler(fetchData, null, setSuccessMessage, respMsgState);

  useEffect(() => {
    if (respMsgState) {
      setSuccessMessage(respMsgState);
    }
  }, [respMsgState]);

  useEffect(() => { }, [shouldShowMsg, responseMessage]);

  const HandleSort = (field) => {
    const newSortBy = sortBy === field ? null : field;
    setSortBy(newSortBy);
    if (newSortBy) {
      rows.sort((a, b) => {
        if (a[newSortBy] < b[newSortBy]) return -1;
        if (a[newSortBy] > b[newSortBy]) return 1;
        return 0;
      });
    } else {
      fetchData();
    }
  };

  const sortedRows = [...rows].sort((a, b) => new Date(b.entry_date) - new Date(a.entry_date));
  const effectiveTotalCount = total_count > 0 ? total_count : rows.length > 0 ? rows.length : 0;
  const startRecord = effectiveTotalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
  const endRecord = effectiveTotalCount === 0 ? 0 : Math.min((controller.page + 1) * controller.rowsPerPage, effectiveTotalCount);
  const paginationInfo = `${startRecord}-${endRecord} of ${total_count}`;


  const calculateTotalCylinders = (tableDetails) => {
    if (Array.isArray(tableDetails)) {
      return tableDetails.filter(item => item.cyl_no && item.cyl_no.trim() !== '').length;
    }
    try {
      const details = JSON.parse(tableDetails || '[]');
      return details.filter(item => item.cyl_no && item.cyl_no.trim() !== '').length;
    } catch {
      return 0;
    }
  };

  const calculateTotalQuantity = (tableDetails) => {
    try {
      const details = JSON.parse(tableDetails || '[]');
      return details.reduce((total, item) => {
        const qty = parseFloat(item.qty) || 0;
        return total + qty;
      }, 0);
    } catch {
      return 0;
    }
  };

  const calculateProductSummary = (tableDetails) => {
    try {
      const details = JSON.parse(tableDetails || '[]');
      const productCounts = {};
      details.forEach(item => {
        if (item.product && item.product.trim() !== '') {
          productCounts[item.product] = (productCounts[item.product] || 0) + 1;
        }
      });
      return Object.entries(productCounts)
        .map(([product, count]) => `${product}: ${count}`)
        .join(', ');
    } catch {
      return 'N/A';
    }
  };

  const handleCloseCylinderDialog = () => {
    setOpenCylinderDialog(false);
    setSelectedCylinderDetails([]);
    setDialogTitle("Cylinder Details");
  };

const getProductCodesSummary = () => {
  if (!Array.isArray(selectedCylinderDetails) || selectedCylinderDetails.length === 0) return "N/A";
  const codes = [...new Set(selectedCylinderDetails.map(c => c.prod_code).filter(Boolean))];
  return codes.length > 0 ? codes.join(", ") : "N/A";
};
const getProductCodesSummaryForRow = (tableDetails) => {
  try {
    const details = JSON.parse(tableDetails || '[]');
    const codes = [...new Set(details.map(c => c.prod_code).filter(Boolean))];
    return codes.length > 0 ? codes.join(", ") : "N/A";
  } catch {
    return "N/A";
  }
};
  // Corrected getOwnerDisplay function
  const getOwnerDisplay = (cylinder) => {
    if (!cylinder) return 'N/A';
    const { owner, customer_id } = cylinder;
    if (owner === 'TGPL') return 'TGPL';
    if (owner === 'customer' && customer_id && customerData[customer_id]) {
      return customerData[customer_id];
    }
    return 'N/A';
  };
  const handleCylinderCountClick = (row) => {
    try {
      const details = JSON.parse(row.table_details || '[]');
      setSelectedCylinderDetails(details);
      setDialogTitle(`Cylinder Details for ${row.entry_no}`);
      setOpenCylinderDialog(true);
    } catch (error) {
      console.error("Error parsing table_details:", error);
      setSuccessMessage("Error loading cylinder details");
    }
  }
  const handleOpenDialog = (row) => {
    setSelectedRow(row); // Make sure this runs before dialog opens
    // const parsed = safeParse(row.table_details);
    setSelectedCylinderDetails(safeParse(row.table_details));
    setOpenDialog(true);
  };

  const safeParse = (jsonString) => {
    try {
      return JSON.parse(jsonString || '[]');
    } catch (e) {
      return [];
    }
  };
  const getCylinderCount = (tableDetails) => {
    try {
      const details = JSON.parse(tableDetails || '[]');
      return details.length || 0;
    } catch (error) {
      console.error("Error parsing table_details:", error);
      return 0;
    }
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRow(null);
    setSelectedCylinderDetails([]);
  };





  return (
    <Box className={`${styles.cts_page}`} sx={{ padding: '0px !important', margin: '0px !important' }}>
      <Box className={`${styles.body}`}>
        <Breadcrumb
          routeSegments={[{ name: "Empty Challan List" }]}
        />
        <HeaderSection
          title="EMPTY CHALLAN LIST"
          addNewPath="/transactions/add-edc"
          searchKey={searchKey}
          handleSearch={handleSearch}
          sortedRows={sortedRows.map(row => ({
            ...row,
            totalCylinders: calculateTotalCylinders(row.table_details),
            totalQuantity: calculateTotalQuantity(row.table_details),
            productsSummary: calculateProductSummary(row.table_details)
          }))}
          fields={fields}
          labels={labels}
          filename="Challan List"
          paginationInfo={paginationInfo}
          controller={controller}
          handleChangePage={handleChangePage}
        />
        <Paper sx={{ width: '100%', }}>
        <TableContainer component={Paper} className={`${styles.list_tbl_container}`}>
          <Table size="small" stickyHeader>
            <TableHead>
              <StyledTableRow>
                <StyledTableCell align="left" className={`${styles.table_head}`} sx={{ width: '12%' }} onClick={() => HandleSort("entry_no")}>
                  Entry No <span className={`${styles.sort_icon}`}>{sortBy === "entry_no" ? "▲" : "▼"}</span>
                </StyledTableCell>
                <StyledTableCell align="left" className={`${styles.table_head}`}  sx={{ width: '12%' }}onClick={() => HandleSort("entry_date")}>
                  Entry Date <span className={`${styles.sort_icon}`}>{sortBy === "entry_date" ? "▲" : "▼"}</span>
                </StyledTableCell>
                <StyledTableCell align="left" className={`${styles.table_head}`} sx={{ width: '12%' }} onClick={() => HandleSort("to_depot")}>
                  Sent To <span className={`${styles.sort_icon}`}>{sortBy === "to_depot" ? "▲" : "▼"}</span>
                </StyledTableCell>
                <StyledTableCell align="left" className={`${styles.table_head}`} sx={{ width: '12%' }} onClick={() => HandleSort("totalCylinders")}>
                  No Of Cylinders <span className={`${styles.sort_icon}`}>{sortBy === "totalCylinders" ? "▲" : "▼"}</span>
                </StyledTableCell>
                <StyledTableCell align="left" className={`${styles.table_head}`} sx={{ width: '12%' }} onClick={() => HandleSort("driver_name")}>
                  Driver Name <span className={`${styles.sort_icon}`}>{sortBy === "driver_name" ? "▲" : "▼"}</span>
                </StyledTableCell>
                <StyledTableCell align="left" className={`${styles.table_head}`} sx={{ width: '12%' }} onClick={() => HandleSort("vehicle_no")}>
                  Vehicle No <span className={`${styles.sort_icon}`}>{sortBy === "vehicle_no" ? "▲" : "▼"}</span>
                </StyledTableCell>
                <StyledTableCell align="left" className={`${styles.table_head}`} sx={{ width: '12%' }} onClick={() => HandleSort("vehicle_no")}>
                  Product Code <span className={`${styles.sort_icon}`}>{sortBy === "prod_code" ? "▲" : "▼"}</span>
                </StyledTableCell>
                
                               {/* <StyledTableCell align="left" className={`${styles.table_head}`} sx={{ width: '12%' }} onClick={() => HandleSort("driver_name")}>
                    From Depot <span className={`${styles.sort_icon}`}>{sortBy === "driver_name" ? "▲" : "▼"}</span>
                </StyledTableCell> */}
                <StyledTableCell align="center" className={`${styles.table_head}`}>
                  Action
                </StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody sx={{ backgroundColor: '#fff' }}>
              {Array.isArray(rows) && rows.map((row, index) => (
                <StyledTableRow key={row.entry_id} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                  <StyledTableCell
                    align="left"
                    className={`${styles.list_table_body}`}
                  >
                    <Typography
                      sx={{
                        fontSize: "12px",
                        fontWeight: "bold",
                        cursor: "pointer",
                        color: "#1976d2",
                        textDecoration: "underline",
                      }}
                      onClick={() => handleOpenDialog(row)}
                    >
                      {row.entry_no || "N/A"}
                    </Typography>


                  </StyledTableCell>
                  <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                    {dateConversion(row?.entry_date)}
                  </StyledTableCell>
                  <StyledTableCell align="left" className={`${styles.list_table_body}`}>
  {row.depot_name ? row.depot_name : row.supplier_name}
</StyledTableCell>

                  <StyledTableCell align="center" className={`${styles.list_table_body}`}>
                    <Tooltip title="Click here to view cylinder details " arrow>
                      <span
                        onClick={() => handleCylinderCountClick(row)}
                        style={{ cursor: 'pointer' }}
                      >
                        {getCylinderCount(row.table_details)}
                      </span>
                    </Tooltip>
                  </StyledTableCell>
                  
                  <StyledTableCell align="left" className={`${styles.list_table_body}`}>
               {row.driver_name || "N/A"}
                  </StyledTableCell>
                  <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                  {row.vehicle_no || "N/A"}
                  </StyledTableCell>
                    <StyledTableCell align="center" className={`${styles.list_table_body}`}>
 {getProductCodesSummaryForRow(row.table_details)}
                  </StyledTableCell>
                  {/* <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                    {row.from_depot_name}
                  </StyledTableCell> */}
                  <StyledTableCell align="center">
                    <CustomePopover
                      row={{
                        ...row,
                        totalCylinders: calculateTotalCylinders(row.table_details),
                        totalQuantity: calculateTotalQuantity(row.table_details),
                        productsSummary: calculateProductSummary(row.table_details),
                      }}
                      handleDelete={false}
                      linkTo="/transactions/add-edc"
                      PrintComponent={EmptyDeliveryChallanPrint}
                      showEdit={false}
                      handleCancel={false}
                    />
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
                          <CustomPagination
  page={controller.page}
  rowsPerPage={controller.rowsPerPage}
  totalCount={total_count || 0}
  onPageChange={(newPage) => handleChangePage(null, newPage)}
/>

        </Paper>

        {/* ── EMPTY CHALLAN DETAILS (Redesigned like Sales Order) ── */}
        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          maxWidth={false}
          sx={{
            "& .MuiDialog-paper": {
              margin: "auto",
              width: "92vw",
              maxHeight: "85vh",
              boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
              overflow: "hidden",
              fontFamily: "'Inter', Arial, sans-serif",
             
            },
          }}
        >
          {/* ── Dialog Header (Navy) ── */}
          <Box sx={{ background: "#1C3A5E", padding: "14px 22px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#fff", letterSpacing: "0.5px", fontFamily: "'Inter', Arial, sans-serif" }}>
              EMPTY CHALLAN DETAILS
            </Typography>
            <IconButton onClick={handleCloseDialog} sx={{ color: "#fff", p: 0.5 }}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>

          <DialogContent sx={{ padding: "20px 24px", background: "#F4F7FB", overflowY: "auto" }}>

            {/* ── Challan Information Card ── */}
            <Box sx={{ background: "#fff", border: "1px solid #E2E8F0",  overflow: "hidden", mb: 2.5 }}>

              {/* Card Header */}
              <Box sx={{ background: "#2A4F7A", padding: "9px 18px" }}>
                <Typography sx={{ fontSize: "12px", fontWeight: 700, color: "#fff", fontFamily: "'Inter', Arial, sans-serif", letterSpacing: "0.4px" }}>
                  📋  Challan Information
                </Typography>
              </Box>

              {/* Clean Grid Layout (No Colons) */}
              <Box>
                <Grid container>
                  
                  {/* Row 1 */}
                  <Grid item xs={12} sm={6} md={4} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>
                      To Depot
                    </Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#1C3A5E", fontFamily: "'Inter', Arial, sans-serif" }}>
                      {selectedRow?.depot_name || "N/A"}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>
                      Entry No
                    </Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>
                      {selectedRow?.entry_no || "N/A"}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4} sx={{ borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>
                      Entry Date
                    </Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>
                      {dateConversion(selectedRow?.entry_date) || "N/A"}
                    </Typography>
                  </Grid>

                  {/* Row 2 */}
                  <Grid item xs={12} sm={6} md={4} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>
                      Driver Name
                    </Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>
                      {selectedRow?.driver_name || selectedRow?.unregistered_driver || "N/A"}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>
                      Vehicle No
                    </Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>
                      {selectedRow?.vehicle_no || selectedRow?.unregistered_vehicle || "N/A"}
                    </Typography>
                  </Grid>
   <Grid item xs={12} sm={6} md={4} sx={{ borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>
                      Product Code
                    </Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>
                      {getProductCodesSummary()}
                    </Typography>
                  </Grid>
                  {/* <Grid item xs={12} sm={6} md={4} sx={{ borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>
                      Challan No
                    </Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>
                      N/A
                    </Typography>
                  </Grid> */}

                </Grid>
              </Box>
            </Box>

            {/* ── Cylinder Details Table ── */}
            <Box sx={{ background: "#fff", border: "1px solid #E2E8F0",  overflow: "hidden" }}>

              {/* Table Header */}
              {/* <Box sx={{ background: "#2A4F7A", padding: "9px 18px" }}>
                <Typography sx={{ fontSize: "12px", fontWeight: 700, color: "#fff", fontFamily: "'Inter', Arial, sans-serif", letterSpacing: "0.4px" }}>
                  📦  Cylinder Details
                </Typography>
              </Box> */}

              <TableContainer sx={{ maxHeight: "320px" }}>
                <Table size="small" stickyHeader>
                  <TableHead>
                    <StyledTableRow>
                      {[
                        "Sr No", "Cylinder No", "Tag No", "Owner","Status","Remark"
                      ].map((header) => (
                        <StyledTableCell
                          key={header}
                          align="center"
                          sx={{
                            backgroundColor: "#1C3A5E !important",
                            color: "#fff !important",
                            fontFamily: "'Inter', Arial, sans-serif",
                            fontWeight: 700,
                            fontSize: "12px",
                            padding: "10px 12px",
                            whiteSpace: "nowrap",
                            borderRight: "1px solid rgba(255,255,255,0.1)",
                          }}
                        >
                          {header}
                        </StyledTableCell>
                      ))}
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {selectedCylinderDetails.length > 0 ? (
                      selectedCylinderDetails.map((row, index) => (
                        <StyledTableRow
                          key={index}
                          sx={{
                            backgroundColor: index % 2 === 0 ? "#fff" : "#F8FAFC",
                            "&:hover": { backgroundColor: "#EBF4FF" },
                          }}
                        >
                          {[
                            index + 1,
                            row.cyl_no || "N/A",
                            row.tag_no || "N/A",
                            row.owner || "N/A",
                             row.status || "N/A",
                            row.remark || ""
                          ].map((val, ci) => (
                            <StyledTableCell
                              key={ci}
                              align="center"
                              sx={{
                                fontSize: "12px",
                                fontFamily: "'Inter', Arial, sans-serif",
                                color: "#2D3748",
                                padding: "8px 12px",
                                borderBottom: "1px solid #EDF2F7",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {val}
                            </StyledTableCell>
                          ))}
                        </StyledTableRow>
                      ))
                    ) : (
                      <StyledTableRow>
                          <StyledTableCell
                          colSpan={6}
                          align="center"
                          sx={{ py: 5, fontSize: "13px", color: "#A0AEC0", fontFamily: "'Inter', Arial, sans-serif" }}
                        >
                          No cylinder details available
                        </StyledTableCell>
                      </StyledTableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>

          </DialogContent>

          {/* ── Dialog Footer ── */}
          <Box sx={{ padding: "12px 24px", background: "#F8FAFC", borderTop: "1px solid #E2E8F0", display: "flex", justifyContent: "flex-end" }}>
            <Button
              onClick={handleCloseDialog}
              sx={{
                background: "#E53E3E",
                color: "#fff",
                fontSize: "13px",
                fontWeight: 600,
                textTransform: "none",
                padding: "7px 20px",
               
                fontFamily: "'Inter', Arial, sans-serif",
                "&:hover": { background: "#971f16" },
              }}
            >
              Close
            </Button>
          </Box>
        </Dialog>




        <Dialog
          open={openCylinderDialog}
          onClose={handleCloseCylinderDialog}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            {dialogTitle}
            <IconButton aria-label="close" onClick={handleCloseCylinderDialog}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Table size="small">
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell>Cylinder No</StyledTableCell>
                  <StyledTableCell>Tag No</StyledTableCell>
                  <StyledTableCell>Owner</StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {selectedCylinderDetails.length > 0 ? (
                  selectedCylinderDetails.map((cylinder, index) => (
                    <StyledTableRow key={index}>
                      <StyledTableCell>{cylinder.cyl_no || 'N/A'}</StyledTableCell>
                      <StyledTableCell>{cylinder.tag_no || 'N/A'}</StyledTableCell>
                      {/* <StyledTableCell>{getOwnerDisplay(cylinder)}</StyledTableCell> */}
                      <StyledTableCell>{cylinder.owner || 'N/A'}</StyledTableCell>
                    </StyledTableRow>
                  ))
                ) : (
                  <StyledTableRow>
                    <StyledTableCell colSpan={3} align="center">
                      No cylinder details available
                    </StyledTableCell>
                  </StyledTableRow>
                )}
              </TableBody>
            </Table>
          </DialogContent>
        </Dialog>
        <DeleteDialog
          open={isDelete}
          handleClose={handleClose}
          deleteInfo={deleteInfo}
          deleteRecord={deleteRecord}
          deleteID={deleteInfo?.entry_id || null}
          displayName={deleteInfo?.entry_id || ""}
        />
        <ReusableSnackbar
          open={!!successMessage}
          onClose={(event, reason) => {
            if (reason !== 'clickaway') {
              setSuccessMessage("");
            }
          }}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />
      </Box>
    </Box>
  );
};

export default EmptyDeliveryChallanList;